import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const Contacts = () => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [chiSei, setChiSei] = useState("");
  const [messaggio, setMessaggio] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "" });
  const { t } = useTranslation();

  useEffect(() => {
    let timer;
    if (toast.show) {
      timer = setTimeout(() => setToast({ show: false, message: "", type: "" }), 4000);
    }
    return () => clearTimeout(timer);
  }, [toast.show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formId = "xrbkdnqg";
    const formUrl = `https://formspree.io/${formId}`;

    try {
      const response = await fetch(formUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nome, email, chi_sei: chiSei, messaggio }),
      });

      if (response.ok) {
        setToast({ show: true, message: t("contacts.toastSuccess"), type: "success" });
        setNome("");
        setEmail("");
        setChiSei("");
        setMessaggio("");
      } else {
        const data = await response.json();
        setToast({ show: true, message: `Errore: ${data.error || response.statusText}`, type: "error" });
      }
    } catch (error) {
      console.error(error);
      setToast({ show: true, message: t("contacts.toastErrorNetwork"), type: "error" });
    }
  };

  return (
    <section id="contacts" className="container mx-auto px-4 py-12">
      {toast.show && (
        <div
          className="fixed top-5 right-5 p-4 rounded-lg shadow-lg z-50
                        bg-violet-500 text-white transform transition-transform duration-300 ease-out animate-fade-in-down"
          role="alert"
        >
          {toast.message}
        </div>
      )}

      <h2
        className="text-2xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight
                     text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400
                     leading-[1.2] py-[0.1em] text-center mb-8"
        data-aos="fade-in"
      >
        {t("contacts.title")}
      </h2>

      <div
        className="w-48 h-1 mx-auto mb-0 md:mb-12 bg-gradient-to-r from-transparent via-purple-300 to-transparent"
        data-aos="fade-up"
      ></div>

      <div className="flex flex-col md:flex-row gap-8 items-start p-5 md:p-4">
        <div className="w-full md:w-1/2 flex flex-col justify-start items-center md:items-start text-center md:text-left mt-8">
          <div className="text-base sm:text-base md:text-md text-gray-300 mb-6 mt-0 md:mt-8">
            <p className="mb-2">
              <strong className="text-purple-300">{t("contacts.emailLabel")}:</strong> info.visiondesign90@gmail.com
            </p>
            <p className="mb-2">
              <strong className="text-blue-300">{t("contacts.countryLabel")}:</strong> {t("contacts.country")}
            </p>
          </div>
          <h3 className="text-xl md:text-2xl font-bold text-blue-300 mb-4">{t("contacts.intro")}</h3>
          <p className="text-base sm:text-base md:text-md text-gray-200 mt-4">{t("contacts.instruction")}</p>
        </div>

        <div className="w-full md:w-1/2">
          <form className="p-8 bg-transparent" onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="name" className="block text-blue-300 text-base font-bold mb-2">
                {t("contacts.nameLabel")}
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="shadow border border-gray-400 rounded w-full py-3 px-3 text-lg md:text-base text-white leading-tight focus:outline-none focus:shadow-outline bg-transparent placeholder:text-gray-400"
                placeholder={t("contacts.namePlaceholder")}
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
              />
            </div>

            <div className="mb-4">
              <label htmlFor="email" className="block text-blue-300 text-base font-bold mb-2">
                {t("contacts.emailLabel")}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="shadow border border-gray-400 rounded w-full py-3 px-3 text-lg md:text-base text-white leading-tight focus:outline-none focus:shadow-outline bg-transparent placeholder:text-gray-400"
                placeholder={t("contacts.emailPlaceholder")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="mb-4">
              <span className="block text-blue-300 text-base font-bold mb-2">{t("contacts.whoAreYouLabel")}</span>
              <div className="mt-2 space-y-3">
                {["privato", "azienda", "freelancer"].map((role) => (
                  <div key={role} className="flex items-center">
                    <input
                      type="radio"
                      id={role}
                      name="who_are_you"
                      value={role}
                      className="h-5 w-5 text-purple-400 focus:ring-purple-500 border-gray-300 peer"
                      checked={chiSei === role}
                      onChange={(e) => setChiSei(e.target.value)}
                    />
                    <label
                      htmlFor={role}
                      className="ml-3 text-lg md:text-base text-gray-200 hover:text-purple-300 cursor-pointer peer-checked:text-purple-400 capitalize"
                    >
                      {t(`contacts.roles.${role}`)}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="message" className="block text-blue-300 text-base font-bold mb-2">
                {t("contacts.messageLabel")}
              </label>
              <textarea
                id="message"
                name="message"
                rows="5"
                className="shadow border border-gray-400 rounded w-full py-3 px-3 text-lg md:text-base text-white leading-tight focus:outline-none focus:shadow-outline bg-transparent placeholder:text-gray-400"
                placeholder={t("contacts.messagePlaceholder")}
                value={messaggio}
                onChange={(e) => setMessaggio(e.target.value)}
                required
              />
            </div>

            <div className="flex items-center justify-center">
              <button
                type="submit"
                className="inline-block bg-gradient-to-br from-purple-700 via-purple-600 to-indigo-600
                                 hover:from-purple-800 hover:via-purple-700 hover:to-indigo-700
                                 text-white font-bold py-3 px-7 text-base sm:text-base md:text-sm shadow-md
                                 marvel-snap-button-shape transition-transform duration-300 ease-in-out hover:scale-105"
              >
                {t("contacts.submit")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
